import { ProductSupplierDoc } from '@gooduncles/gu-app-schema';
import { useState } from 'react';
import { useEffect } from 'react';
import { observeProductSupplier } from 'src/utils/firebase/firebase-short-cut';

const useProductSuppliers = () => {
  const [productSuppliers, setProductSuppliers] = useState<ProductSupplierDoc[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const productSuppliers$ = observeProductSupplier([['deletedAt', '==', null]]);
    const subscription = productSuppliers$.subscribe((productSuppliers) => {
      setProductSuppliers(productSuppliers);
      setLoading(false);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return { productSuppliers, loading };
};

export default useProductSuppliers;
